<template>
  <div class="flex flex-col gap-4 mb-4">
    <p>
      <span class="rounded px-2 py-1 mr-1" :class="activeColorClass"> En cours à votre niveau </span>
      = Je dois intervenir sur le parapheur
    </p>
    <p>
      <span class="rounded px-2 py-1 mr-1" :class="defaultColorClass"> En amont </span>
      = Le parapheur sera prochainement à mon niveau
    </p>
    <p>
      <span class="rounded px-2 py-1 mr-1" :class="defaultColorClass"> En aval </span>
      = Je n'ai pas ou plus besoin d'intervenir sur le parapheur
    </p>
    <p class="flex items-center gap-1">
      <span class="font-bold">A noter </span>: Une erreur, un document à ajouter,... vous pouvez, à tout moment, prendre
      la main sur les parapheurs situés en amont ou en aval
      <PButton mode="secondary" size="sm"> Je prends la main</PButton>
    </p>
    <p class="flex items-center gap-1">
      Optimiser votre suivi avec la recherche
      <PButton class="shrink-0 rounded-tr-md" size="sm">
        <OhVueIcon :name="searchIcon" class="mr-1" />
        Rechercher
      </PButton>
    </p>
    <PAccordion label="Recherche avancée" label-tag="h2" class="[&>button]:border-grey-625 border-b-grey-625">
      <div class="flex flex-col gap-1">
        <p>Je peux faire une recherche avec un ou plusieurs mots clés</p>
        <p>Ajouter * au début du mot pour élargir la recherche</p>
        <p>
          Je peux utiliser des filtres rapides
          <PSelectableTag class="ml-1" v-model="select"> Urgent</PSelectableTag>
        </p>
        <p>Je peux faire une recherche par type de fichier</p>
        <p>Je peux faire une recherche par période</p>
        <p>Je peux exporter ma cherche sur un format tableur (.csv)</p>
      </div>
    </PAccordion>
    <PAccordion label="Parapheurs archivés" label-tag="h2" class="[&>button]:border-grey-625 border-b-grey-625">
      <ul class="list-disc pl-6">
        <li>Ils ne sont plus visibles dans la bannette "En aval"</li>
        <li>Pour les visualiser, il faut cliquer sur le lien "Mes archivés"</li>
      </ul>
    </PAccordion>
  </div>
</template>

<script setup lang="ts">
import { PAccordion, PButton, PSelectableTag, useIcons } from "@pasta/box-v2";
import { OhVueIcon } from "oh-vue-icons";
import { RiSearchLine } from "oh-vue-icons/icons";
import { ref } from "vue";
import { useLetterFileColor } from "../../composable/useLetterFileColor.ts";

const [searchIcon] = useIcons(RiSearchLine);

const { defaultColorClass, activeColorClass } = useLetterFileColor();

const select = ref<boolean>(false);
</script>
